import './GcoversFeaturedBanner.css';

interface FeaturedCard {
   src: string;
   alt: string;
   /** GIF cards animate and must load eagerly; static cards can lazy-load. */
   animated?: boolean;
}

const FEATURED_CARDS: FeaturedCard[] = [
   {
      src: '/assets/images/g-covers/card-tour-championship.png',
      alt: 'Tour Championship – The Georgian Suite (Legendary)',
   },
   {
      src: '/assets/images/g-covers/card-bettinardi.png',
      alt: 'Bettinardi Tour-Grade Pro Package (Epic)',
   },
   {
      src: '/assets/images/g-covers/card-vip-school.png',
      alt: 'Performance Golf VIP School (Legendary)',
   },
   {
      src: '/assets/images/g-covers/card-grand-prize.gif',
      alt: 'G Covers Grand Prize – Sand Valley (Legendary)',
      animated: true,
   },
];

const BANNER_BG = '/assets/images/g-covers/banner-bg.png';

export function GcoversFeaturedBanner() {
   return (
      <div
         className="g-covers-featured-banner"
         style={{ backgroundImage: `url('${BANNER_BG}')` }}>
         <div className="g-covers-featured-row">
            {FEATURED_CARDS.map((card) => (
               <img
                  key={card.src}
                  src={card.src}
                  alt={card.alt}
                  className="g-covers-featured-card"
                  loading={card.animated ? 'eager' : 'lazy'}
                  draggable={false}
               />
            ))}
         </div>
      </div>
   );
}
